<header class="fids-top-header fixed">
  <div class="fids-top-header-row">
    <div class="align-start">
      <div class="fids-logo m-b-10">
        <a style="cursor: default;">
          <img src="./assets/images/ey-logo-white-header.png" alt="logo">
        </a>
      </div>
      <div class="fids-app-name">
        <h3>
          <a style="cursor: default;color: inherit;text-decoration: none;">{{applicationName}}</a>
        </h3>
      </div>
    </div>
    <div class="align-end inline-flex action-buttons">
      <div id="profileTray">
        @if(this.userAuthService.checkPermission('MANAGE.SERVICES.ENVIRONMENTS.VIEW') ||
        this.userAuthService.checkPermission('MANAGE.SERVICES.ENVIRONMENTS.ADD') ||
        this.userAuthService.checkPermission('MANAGE.SERVICES.ENVIRONMENTS.MODIFY'))
        {
        <button class="mdc-icon-button ml-0 pr-0 text-align-end" [routerLink]="['/release/services']" matTooltip="Manage Environments and Services" matTooltipPosition="below" matTooltipClass="ey-custom-tooltip">
          <span class="mr-0 ml-2 fs-18 material-icons" aria-hidden="true">settings</span>
        </button>
        }
        @if(this.userAuthService.checkPermission('MANAGE.USERS.ROLES'))
        {
        <button *ngIf="IsloggedInUserAdmin" class="mdc-icon-button ml-0" [routerLink]="['/release/manage']"  matTooltip="Manage Accounts" matTooltipPosition="below" matTooltipClass="ey-custom-tooltip">
            <span class="material-icons">manage_accounts</span>
          </button>
        }
        <span class="user-label"><strong>{{loggedInUserEmail}}</strong></span>
        <button class="mdc-icon-button ml-0" (click)="logOut()"  matTooltip="Logout" matTooltipPosition="below" matTooltipClass="ey-custom-tooltip">
           <span class="ey-dna-icon-Logout material-icons"></span>
        </button>
        <div class="profile-template profile-float-div" id="profilePanel"></div>
      </div>
    </div>


  </div>
</header>